import React from 'react';
import './ModuleLabels.css';

interface ModuleLabelsProps {
  modules: string[];
  compact?: boolean; // Para mostrar versión compacta (A, C)
}

const getModuleDisplayName = (moduleKey: string, compact = false): string => {
  if (compact) {
    switch (moduleKey) {
      case 'use_accounting_system': return 'C';
      case 'acuse_recibo_module': return 'A';
      default: return moduleKey.charAt(0).toUpperCase();
    }
  }
  
  switch (moduleKey) {
    case 'use_accounting_system': return 'Causación';
    case 'acuse_recibo_module': return 'Acuse';
    default: return moduleKey;
  }
};

const ModuleLabels: React.FC<ModuleLabelsProps> = ({ modules, compact = false }) => {
  if (!modules || modules.length === 0) {
    return null; // No mostrar nada si no hay módulos
  }

  return (
    <div className={`module-labels ${compact ? 'compact' : ''}`}>
      {modules.map((module, index) => (
        <span 
          key={index} 
          className={`module-label ${module} ${compact ? 'compact' : ''}`}
          title={compact ? getModuleDisplayName(module, false) : undefined}
        >
          {getModuleDisplayName(module, compact)}
        </span>
      ))}
    </div>
  );
};

export default ModuleLabels;
